module.exports = __webpack_public_path__ + "img/slider-arrow-left.6fe0377.svg";


//////////////////
// WEBPACK FOOTER
// ./static/img/slider-arrow-left.svg
// module id = rxfv
// module chunks = 0 1 2 5 6